import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Bar } from 'react-chartjs-2'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import NoData from 'components/common/NoData/NoData'
import WidgetContainer from 'components/Apps/WidgetContainer'
import * as COLOR from 'constants/colors'
import messages from '../translate'

class TotalSeaLice extends Component {
  getAllSitesData = () => {
    const {
      intl: { formatMessage },
    } = this.props
    const sitesData = this.props.sitesData.toArray()
    const juvenileArray = []
    const mobileAdultsArray = []
    const gravidFemalesArray = []
    const backgroundColorGravidFemales = []

    for (const key in sitesData) {
      if (sitesData.hasOwnProperty(key)) {
        const weeksData = sitesData[key].weeks

        juvenileArray.push(weeksData.slice(-1)[0].juveniles)
        mobileAdultsArray.push(weeksData.slice(-1)[0].mobile_adult)
        gravidFemalesArray.push(weeksData.slice(-1)[0].pregnant_female)
        backgroundColorGravidFemales.push(
          weeksData.slice(-1)[0].pregnant_female < 3
            ? COLOR.RAW_ASPHALT
            : COLOR.DELICATE_PINK,
        )
      }
    }

    return {
      data: [
        {
          backgroundColor: backgroundColorGravidFemales,
          data: gravidFemalesArray,
          label: formatMessage(messages.gravidFemales),
        },
        {
          backgroundColor: COLOR.CLEAN_SKY,
          data: mobileAdultsArray,
          label: formatMessage(messages.mobileAdults),
        },
        {
          backgroundColor: COLOR.LIGHT_GRAY,
          data: juvenileArray,
          label: formatMessage(messages.juvenile),
        },
      ],
    }
  }

  getSingleSiteData = () => {
    const {
      activeSite,
      sitesData,
      intl: { formatMessage },
    } = this.props
    const juvenileArray = []
    const mobileAdultsArray = []
    const gravidFemalesArray = []
    const backgroundColorGravidFemales = []
    const site = sitesData.get(activeSite)

    for (const key in site.weeks) {
      if (site.weeks.hasOwnProperty(key)) {
        const week = site.weeks[key]
        juvenileArray.push(week.juveniles)
        mobileAdultsArray.push(week.mobile_adult)
        gravidFemalesArray.push(week.pregnant_female)
        backgroundColorGravidFemales.push(
          week.pregnant_female < 3 ? COLOR.RAW_ASPHALT : COLOR.DELICATE_PINK,
        )
      }
    }

    return {
      data: [
        {
          backgroundColor: backgroundColorGravidFemales,
          data: gravidFemalesArray,
          label: formatMessage(messages.gravidFemales),
        },
        {
          backgroundColor: COLOR.CLEAN_SKY,
          data: mobileAdultsArray,
          label: formatMessage(messages.mobileAdults),
        },
        {
          backgroundColor: COLOR.LIGHT_GRAY,
          data: juvenileArray,
          label: formatMessage(messages.juvenile),
        },
      ],
    }
  }

  getWeeks = () => {
    const weeks = []
    const site = this.props.sitesData.get(0)

    for (const key in site.weeks) {
      if (site.weeks.hasOwnProperty(key)) {
        weeks.push(site.weeks[key].week)
      }
    }

    return weeks
  }

  getChartLabels = () => {
    const sites = this.props.sitesData.toArray()

    return sites.map(item => item.site_name)
  }

  chartData = () => {
    const { activeSite, sitesData } = this.props
    const { data } =
      activeSite !== null && sitesData.get(activeSite)
        ? this.getSingleSiteData()
        : this.getAllSitesData()
    const weeks = this.getWeeks()
    const singleSiteLabels = []

    for (const week in weeks) {
      if (weeks.hasOwnProperty(week)) {
        singleSiteLabels.push(`W${weeks[week]}`)
      }
    }

    const allSitesLabels = this.getChartLabels()

    return {
      labels:
        activeSite !== null && sitesData.get(activeSite)
          ? singleSiteLabels
          : allSitesLabels,
      datasets: data,
    }
  }

  optionData = () => ({
    aspectRatio: ifWindowWidthLessThan(768) ? 1.25 : 2.5,
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    plugins: {
      datalabels: {
        display: false,
      },
    },
  })

  getUnitName = () => {
    const { licensee, site } = this.props.userData
    const licenseeCheck = licensee ? licensee.name : ''

    return site ? site.name : licenseeCheck
  }

  render() {
    const {
      sitesData,
      userData,
      unit,
      intl: { formatMessage },
    } = this.props

    if (sitesData.toArray().length === 0) {
      return <NoData />
    }

    return (
      <WidgetContainer
        name={{
          start: unit || this.getUnitName(),
          end:
            userData.site !== null
              ? formatMessage(messages.weeklySummary)
              : formatMessage(messages.siteComparison),
        }}>
        <div className="chart-container">
          <Bar
            width={null}
            height={null}
            data={this.chartData()}
            options={this.optionData()}
            datasetKeyProvider={() => Math.random()}
          />
        </div>
      </WidgetContainer>
    )
  }
}

export default connect(
  state => ({
    sitesData: state.getIn(['seaLice', 'sitesData']),
    activeSite: state.getIn(['seaLice', 'activeSite']),
    userData: state.getIn(['profile', 'profile']).toJS(),
  }),
  null,
)(injectIntl(TotalSeaLice))
